// extracted by mini-css-extract-plugin
export default {"check":"CheckIcon_check__MzcoX","icon":"CheckIcon_icon__MILTg"};